import { Icon } from "@blueprintjs/core";
import { LoaderIcon } from "lucide-react";
import AudioPlayer from "react-h5-audio-player";

import { cn } from "@/lib/utils";

function Clickable({
  children,
  onClick,
  disabled,
}: {
  children: React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
}) {
  return (
    <div
      className={cn(
        "flex items-center gap-1.5 select-none",
        disabled ? "cursor-not-allowed" : "cursor-pointer",
      )}
      onClick={disabled ? undefined : onClick}
    >
      <div
        className={cn(
          "flex h-6 w-6 items-center justify-center rounded-full text-white",
          disabled ? "bg-primary-700/40" : "bg-primary-700",
        )}
      >
        {children}
      </div>
      <div
        className={cn(
          "pt-px text-sm font-bold",
          disabled ? "text-primary-700/40" : "text-primary-700",
        )}
      >
        Preview
      </div>
    </div>
  );
}

function PlayButton({
  disabled,
  onClick,
}: {
  disabled?: boolean;
  onClick?: () => void;
}) {
  return (
    <Clickable disabled={disabled} onClick={onClick}>
      <div className="pb-0.5 pl-0.5">
        <Icon icon="play" size={16} />
      </div>
    </Clickable>
  );
}

function PauseButton({ disabled }: { disabled?: boolean }) {
  return (
    <Clickable disabled={disabled}>
      <Icon icon="pause" size={16} />
    </Clickable>
  );
}

export function AudioPreview({
  audioUrl,
  onPreviewClick,
  autoPlay = false,
  loading = false,
  disabled = false,
}: {
  audioUrl?: string;
  onPreviewClick?: () => void;
  autoPlay: boolean;
  loading: boolean;
  disabled: boolean;
}) {
  if (loading) {
    return (
      <Clickable disabled={disabled}>
        <LoaderIcon className="animate-spin" size={16} />
      </Clickable>
    );
  }

  if (audioUrl) {
    return (
      <AudioPlayer
        src={audioUrl}
        autoPlay={autoPlay}
        showJumpControls={false}
        customVolumeControls={[]}
        customAdditionalControls={[]}
        customProgressBarSection={[]}
        customIcons={{
          play: <PlayButton disabled={disabled} />,
          pause: <PauseButton disabled={disabled} />,
        }}
      />
    );
  } else {
    return <PlayButton disabled={disabled} onClick={onPreviewClick} />;
  }
}
